export default {
  'forms.radio_buttons.option.yes': 'Yes',
  'forms.radio_buttons.option.no': 'No'
}
